import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { genericUnitField, ghgCategoryField } from './common/sharedFields';
import { msg } from '@lingui/core/macro';
import {
  buildingHeatSourceField,
  ceeBuildingAreaQuantityField,
} from './common/buildingCommonFields';
import { locationCountryField } from './common/locationFields';
import { percentRenewableField } from './common/electricityFields';

export const ceeBuildingScope2Metadata = {
  displayName: msg({
    message: 'CEE Building Scope 2',
    context: 'Activity data schema name for CEE Building Scope 2',
  }),
  fields: {
    ...coreFields,
    ghg_category_id: ghgCategoryField,
    building_heat_source: buildingHeatSourceField,
    country: locationCountryField,
    percent_renewable: percentRenewableField,
    quantity: ceeBuildingAreaQuantityField,
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
